import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ContentRoute } from "../../../_metronic/layout";
import WalletTransactions from "./WalletTransactions/WalletTransactions";
import TopupRequests from "./TopupRequests/TopupRequests";
import WithdrawRequests from "./WithdrawRequests/WithdrawRequests";
import { authCheckState } from "../../../store/actions/index";

export default function WalletRouter() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(authCheckState());
  }, [dispatch]);

  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to="wallet-transactions" replace />}
      />

      <Route
        path="wallet-transactions"
        element={<WalletTransactions />}
      />

      <Route path="topup-requests" element={<TopupRequests />} />

      <Route path="withdraw-requests" element={<WithdrawRequests />} />
    </Routes>
  );
}
